import { render, staticRenderFns } from "./balanceRecord.vue?vue&type=template&id=346f38c7&scoped=true"
import script from "./balanceRecord.vue?vue&type=script&lang=js"
export * from "./balanceRecord.vue?vue&type=script&lang=js"
import style0 from "./balanceRecord.vue?vue&type=style&index=0&id=346f38c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f38c7",
  null
  
)

export default component.exports